import { useQuery } from '@tanstack/react-query'
import { getCategories } from 'SpendControl/endpoints/spend-control'
import type { SpendControlTableProps } from 'SpendControl/SpendControlTable'

export const useCategories: SpendControlTableProps['useCategories'] = ({ partner }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['get-spend-categories', partner],
    queryFn: () => getCategories(partner as string),
    enabled: Boolean(partner),
  })

  return {
    data: data?.map((row) => ({ id: row.id, name: row.name, description: row.description, partner: row.cardPartner, ruleId: row.ruleId })),
    isLoading,
  }
}
